import {FiltersViewModel} from '@/src/features/catalog/filters-v2'
import {serializeFiltersToQuery} from '@/src/features/catalog/filters-v2/utils/filter-url.utils'
import {ReadonlyURLSearchParams} from 'next/dist/client/components/readonly-url-search-params'
import {AppRouterInstance} from 'next/dist/shared/lib/app-router-context.shared-runtime'
import qs from 'qs'
import {getInjection} from '@runlab/di'
import {CatalogEvents} from '@/src/core/domain/events/catalog.events'

export const navigateToFilters = (
  vm: FiltersViewModel,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
) => {
  const serialized = serializeFiltersToQuery(
    vm.data.filters.filter((f): f is NonNullable<typeof f> => f !== null) as any,
  )

  const current = qs.parse(searchParams.toString())

  const hasFilters = Object.keys(serialized).length > 0

  const next = {...current}
  if (hasFilters) {
    next.filter = serialized as any
  } else {
    delete next.filter
  }

  const nextStr = qs.stringify(next)
  const currentStr = qs.stringify(current)

  if (nextStr !== currentStr) {
    getInjection('IEventBus').publish(CatalogEvents.filtersApply())

    router.replace(`${pathname}${nextStr ? `?${nextStr}` : ''}`)
  }
}
